/**
 * Internal error helpers for the `@chatsdet/browser-core` package.
 *
 * Tiny, unopinionated. The cross-cutting `@chatsdet/errors` package is
 * for Effect-typed code paths; browser-core is non-Effect and just
 * needs a consistent stringifier for `unknown` thrown values.
 *
 * @module
 */

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
